'use client'

import { Box, useMultiStyleConfig } from '@chakra-ui/react'
import React from 'react'

type Props = {
  url: string
}

export function BannerBackgroundImage({ url }: Props) {
  const styles = useMultiStyleConfig('FlightAviosOnlyBanner', {})
  return <Box sx={{ ...styles.bgImage, backgroundImage: `url(${url})` }} />
}
